import { defineMessages } from 'react-intl';

const messages = defineMessages({
  // Page SEO
  seoTitle: 'Accommodations - LodgeLink',
  bannerSubTextNotLoggedIn: 'A LodgeLink account is required to search and make reservations for your crew.',
  notLoggedInCTAText: 'Join Now To Access Discounted Rates',
  notLoggedInSignInText: 'Already have an account? ',
  notLoggedInSignInCTAText: 'Sign in',
  warningTitle: 'Your organization has preferred properties',
  warningMessage: `Choose cancel to return to the properties list and select a preferred property or continue with your selection`
});

export default messages;
